import React from 'react'

interface MobileStickyFooterProps {
  children: React.ReactNode
}

/**
 * Pins a phase's primary action to the viewport bottom on mobile (when
 * the page is taller than the screen) without changing the desktop
 * layout.
 *
 * Uses `position: sticky` rather than `fixed` so the element stays in
 * the document flow (no manual `pb-X` on the parent to reserve space)
 * and only pins once the user scrolls past it. Requires a scrolling
 * ancestor with no `overflow: hidden` on the path — the OnboardingShell
 * root provides this via `overflow-y-auto`.
 *
 * Background uses an arbitrary rgb-with-alpha value rather than
 * `bg-bg/85`: the `.bg-bg` shim is a static color, and Tailwind's `/N`
 * opacity modifier only composes with theme-config colors. Without
 * the alpha the backdrop-blur has nothing to blur through.
 */
export const MobileStickyFooter: React.FC<MobileStickyFooterProps> = ({ children }) => (
  <div className="sticky bottom-0 z-10 -mx-5 flex flex-col items-center gap-3 border-t border-line bg-[rgb(8_9_11/0.85)] px-5 pt-4 pb-[max(env(safe-area-inset-bottom),16px)] backdrop-blur-md sm:static sm:m-0 sm:border-0 sm:bg-transparent sm:p-0 sm:backdrop-blur-none">
    {children}
  </div>
)
